import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

function AddActivity() {
    const [name, setName] = useState("")
    const [description, setDescription] = useState("")
    const navigate = useNavigate()

    const handleSubmit = async (event) => {
        event.preventDefault();
        const token = localStorage.getItem("token");
        try {
            const response = await fetch(
                "https://fitnesstrac-kr.herokuapp.com/api/activities/",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        name: name,
                        description: description
                    }),
                }
            );
            const result = await response.json();
                navigate("/Activities");
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="form-container" >
            <form onSubmit={handleSubmit}>
                <h1>Add an Activity</h1>
                <div>
                    <label htmlFor="name"></label>
                    <input
                        type="text"
                        id="name"
                        placeholder="Activity Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div>
                    <label htmlFor="description"></label>
                    <input
                        type="text"
                        id="description"
                        placeholder="Activity Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
                <button className="submit-btn" type="submit">Create Activity</button>
            </form>
        </div>
    );
}

export default AddActivity